/**
 * Severity and state token lookups. Kept out of the component file so both the
 * badges and the charts read the same source of truth (and so fast refresh
 * keeps working).
 */
import type { AlarmState, Severity } from './schemas.js';

export interface ToneTokens {
  ink: string;
  soft: string;
  label: string;
}

export const SEVERITY_TOKENS: Record<Severity, ToneTokens> = {
  critical: { ink: 'var(--sev-critical)', soft: 'var(--sev-critical-soft)', label: 'Critical' },
  major: { ink: 'var(--sev-major)', soft: 'var(--sev-major-soft)', label: 'Major' },
  warning: { ink: 'var(--sev-warning)', soft: 'var(--sev-warning-soft)', label: 'Warning' },
  info: { ink: 'var(--sev-info)', soft: 'var(--sev-info-soft)', label: 'Info' },
};

export type StateTone = AlarmState | 'suppressed';

export const STATE_TOKENS: Record<StateTone, ToneTokens> = {
  open: { ink: 'var(--state-open)', soft: 'var(--state-open-soft)', label: 'Open' },
  acknowledged: {
    ink: 'var(--state-acknowledged)',
    soft: 'var(--state-acknowledged-soft)',
    label: 'Acknowledged',
  },
  snoozed: { ink: 'var(--state-snoozed)', soft: 'var(--state-snoozed-soft)', label: 'Snoozed' },
  closed: { ink: 'var(--state-closed)', soft: 'var(--state-closed-soft)', label: 'Closed' },
  suppressed: {
    ink: 'var(--state-suppressed)',
    soft: 'var(--state-suppressed-soft)',
    label: 'Suppressed',
  },
};

export function severityInk(severity: Severity): string {
  return SEVERITY_TOKENS[severity].ink;
}

export function severityLabel(severity: Severity): string {
  return SEVERITY_TOKENS[severity].label;
}

export function stateInk(state: StateTone): string {
  return STATE_TOKENS[state].ink;
}

export function stateLabel(state: StateTone): string {
  return STATE_TOKENS[state].label;
}
